// extracted by mini-css-extract-plugin
module.exports = {"root":"MQdy6l7N","badge":"D7il4Gg3","breaking":"msGTMJ7g","watchlist":"mMGSi2zT"};